import React, { Component } from 'react';
import { Routes, Route } from 'react-router-dom';
import { TermsOfService } from './public/TermsOfService';

export class PublicLayoutLarge extends Component {
    static displayName = PublicLayoutLarge.name;
    constructor(props) {
        super(props);
        this.backgroundImage = this.getBackgroundImage();
    }

    getBackgroundImage() {
        var imageIndex = (Math.floor(Math.random() * 9) + 1).toString().substr(-2);
        var indexPadding = 2 - imageIndex.length;
        var imageString = '/images/bg_site_' + ('0' * indexPadding) + imageIndex + '.jpg';
        return imageString;
    }

    render() {
        const style = {
            backgroundImage: 'url("' + this.backgroundImage + '")',
            backgroundSize: 'cover',
            height: '100%'
        }
        return (
            <div className="col-md-12 col-md-offset-6 loginFormWrapperContainer" style={style} >
                <div className="loginFormWrapper">
                    <div className="publicFormContent">
                        <img src="/images/logo_phoenix_red.png" className="logo-main-login" title="Phoenix Logo" alt="Phoenix logo" />
                        <Routes>
                            <Route exact path="/TermsOfService" element={<TermsOfService />} />
                        </Routes>
                        <div className="logo-footer-container">
                            <img src="/logo_tcoe_black_md.png" title="TCOE logo" alt="Phoenix logo" className="logo-footer-small" />
                        </div>
                    </div>
                </div>
            </div> 
        );
    }
}
